import { AccessActivityView } from "@/features/caregiver/access-activity/components/AccessActivityView";

export function AccessActivityPage() {
  return <AccessActivityView />;
}
